import React from 'react';
import TopAppBar from './TopAppBar';
import BottomNavBar from './BottomNavBar';

function AppShell({ activeTab, onTabChange, userEmail, children }) {
  return (
    <div className="min-h-screen bg-surface">
      <TopAppBar userEmail={userEmail} />
      <main className="pt-16 pb-24 px-5 max-w-lg mx-auto w-full">
        {children}
      </main>
      <BottomNavBar activeTab={activeTab} onTabChange={onTabChange} />
    </div>
  );
}

export default AppShell;
